import React from 'react'

const NavButtonCta = ({ device, data, children }) => {
	const devices = () => {
		if (Array.isArray(device)) {
			return device.map((value) => `for-${value}`).join(' ')
		}

		if (typeof device === 'string') {
			return `for-${device}`
		}

		return ''
	}

	return (
		<ul className={`nav_buttons_cta ${devices()}`} data-display={data}>
			{children}
		</ul>
	)
}

export default NavButtonCta
